export default __webpack_public_path__ + "static/media/icon-variance-positive-up.c2650388.svg";